exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".teaching-profile-form .teaching-profile-form__edit-btn{margin-top:8px}.teaching-profile-form__switch-pad-wrapper{display:flex}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};